import { MockDebug } from '@tino-frontend/mocks'
import { tutorialsAPIMock } from '@fixtures/apis/tutorials'
import { REACT_APP_MERCHANT_BFF_API_URL } from 'constants/envs'

// Service: Tutorial
const MockDebugTutorialListAll: MockDebug = {
  title: 'tutorial list',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/tutorial`,
  method: 'get',
  delay: 0,
  options: [
    {
      id: 'mock-tutorial-listAll-empty',
      title: 'listAll-empty',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: [],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-tutorial-All-v0',
      title: 'all-V0',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: [
            'buyerBalance_v0',
            'buyerNextBill_v0',
            'buyerMenu_v0',
            'buyerInvoice_v0',
            'buyerBillTimeline_v0',
            'buyerBillHelpMenu_v0',
          ],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-tutorial-1-item-balance',
      title: 'item-1-balance',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: ['buyerBalance_v0'],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-tutorial-2-item-next-bill',
      title: 'item-2-next-bill',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: ['buyerBalance_v0', 'buyerNextBill_v0'],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-tutorial-3-item-menu',
      title: 'item-3-menu',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: ['buyerBalance_v0', 'buyerNextBill_v0', 'buyerMenu_v0'],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-tutorial-4-item-invoice',
      title: 'item-4-invoice',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: [
            'buyerBalance_v0',
            'buyerNextBill_v0',
            'buyerMenu_v0',
            'buyerInvoice_v0',
          ],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-tutorial-5-item-timeline',
      title: 'item-5-timeline',
      status: 200,
      data: tutorialsAPIMock.build(
        {
          tutorials: [
            'buyerBalance_v0',
            'buyerNextBill_v0',
            'buyerMenu_v0',
            'buyerInvoice_v0',
            'buyerBillTimeline_v0',
          ],
        },
        { mergeArray: false }
      ),
    },
  ],
}

const MockDebugTutorialView: MockDebug = {
  title: 'save viewed',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/tutorial/:tutorialId`,
  method: 'post',
  delay: 0,
  options: [
    {
      id: 'mock-tutorial-viewed-empty',
      title: 'response empty',
      status: 200,
      data: {
        tutorials: [],
      },
    },
    {
      id: 'mock-tutorial-viewed-all',
      title: 'response all V0',
      status: 200,
      data: {
        tutorials: [
          'buyerBalance_v0',
          'buyerNextBill_v0',
          'buyerMenu_v0',
          'buyerInvoice_v0',
          'buyerBillTimeline_v0',
          'buyerBillHelpMenu_v0',
        ],
      },
    },
    {
      id: 'mock-tutorial-viewed-timeline',
      title: 'response Timeline',
      status: 200,
      data: {
        tutorials: [
          'buyerBalance_v0',
          'buyerNextBill_v0',
          'buyerMenu_v0',
          'buyerInvoice_v0',
          'buyerBillTimeline_v0',
        ],
      },
    },
  ],
}

export const MockDebugTutorial = [
  MockDebugTutorialListAll,
  MockDebugTutorialView,
]
